<template>
  <Dropdown
    v-model="selectedUser"
    :options="users"
    @change="onSelectUser"
    optionValue="id"
    filter
    :filterFields="['id', 'name', 'surname']"
    appendTo="body"
    :class="{ 'p-invalid': v$.selectedUser.$error }"
    v-bind="$attrs"
    :loading="isLoading"
  >
    <template #value="props">
      <span v-if="props.value"
        >{{ props.value }} -
        {{ users.find((x) => x.id === props.value)?.prename }}
        {{ users.find((x) => x.id === props.value)?.name }}
        {{ users.find((x) => x.id === props.value)?.surname }}</span
      >
      <span v-else>
        &nbsp;
      </span>
    </template>
    <template #option="props">
      <div>
        {{ props.option.id }} - {{ props.option.prename }}
        {{ props.option.name }} {{ props.option.surname }}
      </div>
      <div class="smalltext">
        {{ props.option.position }} - {{ props.option.divisionDescription }} /
        {{ props.option.departmentDescription }}
        {{ props.option.level ? ` / L.${props.option.level}` : "" }}
      </div>
    </template>
  </Dropdown>
  <small class="p-error" v-if="v$.selectedUser.$error">{{
    v$.selectedUser.required.$message
  }}</small>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from "vue";
import { usePlugin } from "@/plugins";
import { Employee, GetEmployeeResponse } from "@/types";
import { useVuelidate } from "@vuelidate/core";
import { requiredIf } from "@vuelidate/validators";

export default defineComponent({
  name: "InputUser",
  props: {
    modelValue: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
    levelMoreThan: {
      type: Number,
      default: 0,
    },
  },
  setup(props, { emit }) {
    const { axios, error, information } = usePlugin();
    const users = ref([] as Employee[]);
    const selectedUser = ref<string | null>("");
    const isLoading = ref(false);

    const rules = {
      selectedUser: {
        required: requiredIf(() => props.required === true),
      },
    };

    const v$ = useVuelidate(rules, { selectedUser });

    const loadUsers = async () => {
      isLoading.value = true;
      try {
        const result = await axios.post<GetEmployeeResponse>(
          "api/v1/services/employee/get",
          {
            searchString: "",
          }
        );
        users.value = result.data.employees ?? [];
        //Not allow user to choose her self
        users.value = users.value.filter(
          (x) => x.level !== null && parseInt(x.level) > props.levelMoreThan
        );
        if ((result.data.employees?.length ?? 0) === 0)
          information("ไม่พบข้อมูล");
      } catch (e) {
        error("ไม่สามารถติดต่อ server กรุณาลองใหม่ภายหลัง");
      } finally {
        isLoading.value = false;
      }
    };

    watch(
      () => props.modelValue,
      () => {
        selectedUser.value = props.modelValue ?? null;
      }
    );
    onMounted(async () => {
      await loadUsers();
      if (props.modelValue) {
        selectedUser.value = props.modelValue;
      }
    });

    const onSelectUser = (value: any) => {
      emit("update:modelValue", value.value);
    };

    return {
      selectedUser,
      users,
      onSelectUser,
      v$,
      isLoading,
    };
  },
});
</script>

<style scoped>
.smalltext {
  font-size: 0.8rem;
  color: grey;
}
</style>
